// extracted by mini-css-extract-plugin
export default {"item":"favwM__item","fileIcon":"Xd0cm__fileIcon","fileName":"_CSmK__fileName"};